import React, {useCallback} from "react";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {ModalPortal} from "features/components/modal";
import {connect} from "react-redux";
import {onboardingReset} from "features/pages/account/onboarding/reducer";
import {shouldShowOnboardingCompleteModal} from "features/pages/account/onboarding/selectors";
import image from "images/logo/marchio-bianco.svg";
import {bool} from "prop-types";

/* istanbul ignore next */
const mapStateToProps = state => ({
    show: shouldShowOnboardingCompleteModal(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    onboardingReset
};

export const OnboardingCompleteModal = (props) => {
    const {onboardingReset, show} = props;
    const finishOnboarding = useCallback(() => {
        onboardingReset();
    }, [onboardingReset]);
    if(!show) {
        return null;
    }
    return <ModalPortal className="onboarding-complete-modal" horizontal={true} size={"large"}>
        <div className="content">
            <Title size={34}>{__("modal.onboarding-complete.title")}</Title>
            <Text size={16}>{__("modal.onboarding-complete.text")}</Text>
            <Button title={__("buttons.next")} onClick={finishOnboarding} icon={"arrow-right"} />
        </div>
        <div className="image">
            <img alt="modal-success" src={image} />
        </div>
    </ModalPortal>
}
OnboardingCompleteModal.propTypes = {
    show: bool
}
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingCompleteModal);
